import React from 'react';
import MuiDialog from '@material-ui/core/Dialog';

import { DialogProps } from './types';

export function Dialog({
  opened,
  size,
  Content,
  onClose,
  initialValues,
  fullScreen,
  dialogClassName,
}: DialogProps & { onClose: () => void }) {
  return (
    <MuiDialog
      maxWidth={size}
      open={opened}
      onClose={onClose}
      fullScreen={fullScreen}
      className={dialogClassName}
    >
      <Content initialValues={initialValues} onClose={onClose} />
    </MuiDialog>
  );
}
